// Shared Small Potatoes social-preview image + the "use the page's own
// image, else this default" rule. Same asset already used as the site-wide
// og:image / apple-touch-icon / JSON-LD logo — reused, not a new asset.
export const DEFAULT_OG_IMAGE =
  "https://smallpotatoes.lon1.cdn.digitaloceanspaces.com/Flavicon/logo.png";

// og:image / twitter:image must be an absolute public URL to render in a
// link preview — a relative path (e.g. a bundled placeholder) or an
// empty/nullish value falls back to the default.
const ABSOLUTE_HTTP_URL_RE = /^https?:\/\/\S+$/i;

export const resolveOgImage = (candidate) => {
  const trimmed = typeof candidate === "string" ? candidate.trim() : "";
  return ABSOLUTE_HTTP_URL_RE.test(trimmed) ? trimmed : DEFAULT_OG_IMAGE;
};
